import PreRegisterView from './PreRegisterView';

export default PreRegisterView;
